module.exports = __webpack_public_path__ + "img/raccars.6b978b37.png";